import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--surface))] px-3.5 py-2.5 text-sm text-[hsl(var(--text))] leading-snug transition-[border-color,box-shadow] duration-150 ease-in-out placeholder:text-[hsl(var(--text-subtle))] hover:border-[hsl(var(--border-strong))] focus-visible:outline-none focus-visible:border-[hsl(var(--gold))] focus-visible:shadow-[0_0_0_3px_hsla(35,47%,60%,0.20)] aria-[invalid=true]:border-[hsl(var(--loss))] aria-[invalid=true]:focus-visible:shadow-[0_0_0_3px_hsla(0,36%,54%,0.20)] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
